import React from 'react';
import { Stars, Moon } from 'lucide-react';
import { FavoriteLocations } from './FavoriteLocations';
import { trackPlannerRun } from '@/lib/analytics';

interface DashboardLocation {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  notes?: string;
  created_at?: string;
}

interface LocationSelectionViewProps {
  onLocationSelect: (location: DashboardLocation) => void;
  plannerType?: 'milkyway' | 'moon';
}

const plannerConfig = {
  milkyway: {
    icon: Stars,
    title: 'Milky Way Planner',
    subtitle: 'Select a location to view galactic core visibility',
  },
  moon: {
    icon: Moon,
    title: 'Moon Planner',
    subtitle: 'Select a location to view lunar photography timing',
  },
};

export const LocationSelectionView: React.FC<LocationSelectionViewProps> = ({
  onLocationSelect,
  plannerType = 'milkyway'
}) => {
  const config = plannerConfig[plannerType];
  const Icon = config.icon;

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 pb-4 border-b border-border">
        <Icon className="w-5 h-5 text-gold" />
        <div>
          <h2 className="text-lg font-semibold text-foreground">{config.title}</h2>
          <p className="text-sm text-muted-foreground">{config.subtitle}</p>
        </div>
      </div>
      <FavoriteLocations
        onLocationSelect={(location) => {
          trackPlannerRun('saved', location.id);
          onLocationSelect(location);
        }}
        selectedLocation={null}
      />
    </div>
  );
};
